var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"d-flex justify-center",attrs:{"src":_vm.getImageUrl('helping_hand/helpingHandHeader.png'),"contain":"","width":"100%"}},[_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"0.5%","color":"white","font-size":"4vw","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }